<div style="height: 100vh;" class="mat-app-background">
    <app-toolbar></app-toolbar>
    <router-outlet></router-outlet>
    <!-- <app-navigation *ngIf="isAuthenticated"></app-navigation>
    <app-connection *ngIf="!isAuthenticated"></app-connection> -->
</div>
